/**
 * パンくずリストで使用するセクション名の定義
 */
export const SECTION_NAMES = {
  // Newtコンテンツ
  'voice': '導入事例',
  'demo': 'デモ',
  'service': 'お役立ち資料',
  'seminar': 'セミナー',
  'column': 'コラム',
  'news': 'お知らせ',

  // ページパス
  'contract': '契約ナレッジマネジメント',
  'regulation': '規程・マニュアル管理',
  'law': '法令改正対応',
  'translation': '英文契約書レビュー',
  'functions': '機能紹介',
  'flow': '料金・導入の流れ',
  'security': 'セキュリティ',
  'partnership': 'パートナーシップ',
  'contact': 'お問い合わせ',
  'request': '資料請求',
  'terms': '利用規約',
  'privacy-policy': 'プライバシーポリシー'
} as const

// 型定義
export type SectionNameKey = keyof typeof SECTION_NAMES
export type ContentTypeKey = 'voice' | 'demo' | 'service' | 'seminar' | 'column' | 'news'

/**
 * パスからセクション名を取得する
 */
export const getSectionName = (path: string): string => {
  return SECTION_NAMES[path as SectionNameKey] || path
}

/**
 * コンテンツタイプからセクション名を取得する
 */
export const getContentTypeName = (contentType: ContentTypeKey): string => {
  return SECTION_NAMES[contentType] || contentType
}
